import { render, staticRenderFns } from "./CraftCommerceVerifiedIcon.vue?vue&type=template&id=c916ab2e"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports